module.exports = __webpack_public_path__ + "static/media/arrow-up-white.df6a8f45.svg";